import type React from 'react';
import { memo } from 'react';
import { Dialog } from '../Dialog';
import type { DialogProps } from '../Dialog/types';

export interface MaxOrderSizeDialogsProps {
  warnDialog: DialogProps;
  rejectDialog: DialogProps;
  warnMessage: React.ReactElement | string | undefined;
  rejectMessage: React.ReactElement | string | undefined;
}

export const MaxOrderSizeDialogs = memo(function MaxOrderSizeDialogs({
  warnDialog,
  rejectDialog,
  warnMessage,
  rejectMessage,
}: MaxOrderSizeDialogsProps) {
  return (
    <>
      <Dialog {...warnDialog}>{warnMessage}</Dialog>
      <Dialog {...rejectDialog}>{rejectMessage}</Dialog>
    </>
  );
});
